module.exports = __webpack_public_path__ + "img/VaccinCovid19gray.3a281b52.svg";